/* eslint-disable global-require */
import i18n from "@/i18n/index";

export const historyData = () => Object.freeze({
    save: {
        edit: {
            icon: require("@/assets/images/vEdited.svg")
        },
        publish: {
            icon: require("@/assets/images/vPublished.svg")
        }
    },
    change: {
        edit: {
            icon: require("@/assets/images/vEdited.svg"),
            verb: `${i18n.t("versioning.edited")}`
        },
        publish: {
            icon: require("@/assets/images/vPublished.svg"),
            verb: `${i18n.t("versioning.published")}`
        },
        recover: {
            icon: require("@/assets/images/vRestored.svg"),
            verb: `${i18n.t("versioning.recovered")}`
        },
        delete: {
            icon: require("@/assets/images/vDeleted.svg"),
            verb: `${i18n.t("versioning.deleted")}`
        },
        rename: {
            icon: require("@/assets/images/vRenamed.svg"),
            verb: `${i18n.t("versioning.renamedTo")}`
        },
        import: {
            icon: require("@/assets/images/vImported.svg"),
            verb: `${i18n.t("versioning.imported")}`
        },
        create: {
            icon: require("@/assets/images/vCreated.svg"),
            verb: `${i18n.t("versioning.created")}`
        }
    }
});
